export const menuItems = [
    { id: 1, label: "Join US", href: "/join-us" },
    { id: 2, label: "About Us", href: "/aboutus" },
    { id: 3, label: "Partners", href: "/champions" , emoji: "🫶🏽"},
    { id: 4, label: "Credentials", href: "/certificates" , emoji: "🏆"},
    { id: 5, label: "Events", href: "/events" },
    { id: 6, label: "Resources", href: "/resources" , emoji: "📁"},
    { id: 7, label: "Say Hi", href: "/contact", emoji: "👋" },
  ];